module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Readers of the Tarzan Novels …")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("… will be familiar with Tarzan’s adventures in the lost city of Opar, with its Atlantean tradition, its fabled jewels, and its living goddess, the famous La of Opar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Millions of readers—and there are millions—have wondered why Edgar Rice Burroughs did not go further into the origins of this lost city—who first built it, in what forgotten Golden Age of Africa did it flourish, what wonders of adventures did its mysterious centuries hide.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now Philip José Farmer has, with the consent of Burroughs’ son, torn away the veil of time to reveal the glory of Opar in its prime, the mighty empire which flourished when Africa had great inland seas where only the barren Sahara now is.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meet Hadon, son of Ancient Opar, in his challenge for the crown of that empire and in his battle against the many forces that would deny it to him.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-027c3731","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Fm01.vue
// module id = 75
// module chunks = 0